// Push-Benachrichtigungen Utility
let VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || '';

// VAPID Public Key vom Server abrufen, falls nicht in .env
export const fetchVapidPublicKey = async (): Promise<string> => {
  if (VAPID_PUBLIC_KEY) {
    return VAPID_PUBLIC_KEY;
  }
  try {
    const response = await fetch('/api/push/vapid-public-key');
    const data = await response.json();
    if (data.publicKey) {
      VAPID_PUBLIC_KEY = data.publicKey;
      return VAPID_PUBLIC_KEY;
    }
  } catch (error) {
    console.error('Fehler beim Abrufen des VAPID Public Keys:', error);
  }
  return '';
};

export const urlBase64ToUint8Array = (base64String: string): Uint8Array => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const registerServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registriert:', registration);
      return registration;
    } catch (error) {
      console.error('Service Worker Registrierung fehlgeschlagen:', error);
      return null;
    }
  }
  return null;
};

export const requestNotificationPermission = async (): Promise<NotificationPermission> => {
  if (!('Notification' in window)) {
    console.log('Dieser Browser unterstützt keine Benachrichtigungen');
    return 'denied';
  }

  if (Notification.permission === 'granted') {
    return 'granted';
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission;
  }

  return Notification.permission;
};

export const subscribeToPush = async (): Promise<PushSubscription | null> => {
  if (!VAPID_PUBLIC_KEY) {
    console.error('VAPID Public Key fehlt');
    return null;
  }

  const registration = await registerServiceWorker();
  if (!registration) {
    return null;
  }

  try {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
    return subscription;
  } catch (error) {
    console.error('Push Subscription fehlgeschlagen:', error);
    return null;
  }
};

export const getExistingSubscription = async (): Promise<PushSubscription | null> => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();
      return subscription;
    } catch (error) {
      console.error('Fehler beim Abrufen der Subscription:', error);
      return null;
    }
  }
  return null;
};

export const unsubscribeFromPush = async (): Promise<boolean> => {
  const subscription = await getExistingSubscription();
  if (subscription) {
    try {
      await subscription.unsubscribe();
      return true;
    } catch (error) {
      console.error('Fehler beim Abmelden:', error);
      return false;
    }
  }
  return false;
};

